import React, { useMemo, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import { Header } from '../../components'
import { getParam } from '../../helpers/parameters'
import OptionsHOC from '../../hocs/OptionsHOC'
import { useAppContext } from '../App/Context'
import {
  selectCurrentPhone,
  selectCustomer,
  selectStyles
} from '../App/selectors'
import { clearDevice } from '../DeviceSelector/actions'
import { selectLandingCategories, selectQuestions } from '../FAQs/selectors'
import { selectGuides } from '../Guides/selectors'
import LanguageProvider from '../LanguageProvider/LanguageProvider'
import { selectTutorials } from '../Tutorials/selectors'
import { createEvent } from '../UserEvents/actions'
import { selectVideos } from '../Videos/selectors'
import { fetchHeader } from './actions'
import { selectError, selectHeader, selectIsFetching } from './selectors'

const HeaderContainer = props => {
  const {
    fetchHeader,
    language,
    isFetching,
    getOption,
    customer,
    tutorials,
    questions,
    guides,
    videos,
    clearDevice
  } = props

  const [allowCustomerOverride, setAllowCustomerOverride] = useState(false)

  const clear = () => {
    const search = language === 'en' ? '' : `?lang=${language}`
    clearDevice()
    browserHistory.push({
      pathname: '/',
      search
    })
  }

  const { versionKey: version } = useAppContext()
  const modulesAvailable = {
    tutorials: tutorials.length > 0,
    faqs: questions.length > 0,
    guides: guides.length > 0,
    videos: videos.length > 0
  }
  const text = language === 'en' ? getOption('header.linkLang.text') : 'ENGLISH'

  const constructUrl = () => {
    const url = new URL(window.location.href)
    const search = new URLSearchParams(url.search)
    language === 'en' ? search.set('lang', getOption('header.linkLang.query')) : search.delete('lang')
    const searchStr = search.toString() ? `?${search.toString()}` : ''
    return `${url.origin}${url.pathname}${searchStr}`
  }
  const topLinks = {
    show: getOption('header.linkLang.show'),
    text,
    url: constructUrl()
  }

  useMemo(() => {
    getParam('allowCustomerOverride').then(value => {
      const renderCustomerOverride = value.toLowerCase() === 'true'

      setAllowCustomerOverride(renderCustomerOverride)
    })
    if (version !== 'v1') {
      fetchHeader(language.substring(0, 2), version)
    }
  }, [language])

  if (isFetching)
    return (
      <div className="flex">
        <FontAwesomeIcon icon={faSpinner} spin />
      </div>
    )

    return (
      <Header
        {...props}
        allowCustomerOverride={allowCustomerOverride}
        modulesAvailable={modulesAvailable}
        clearDevice={clear}
        topLinks={topLinks}
        version={version}
      />
    )
}

const mapStateToProps = (state, ownProps) => ({
  location: ownProps.location,
  styles: selectStyles(state),
  customer: selectCustomer(state),
  query: state.routing.locationBeforeTransitions.query,
  landingCategories: selectLandingCategories(state),
  devices: ownProps.devices,
  currentDevice: selectCurrentPhone(state),
  questions: selectQuestions(state),
  videos: selectVideos(state),
  guides: selectGuides(state),
  tutorials: selectTutorials(state),
  toggleDeviceModal: ownProps.toggleDeviceModal,
  toggleSearchModal: ownProps.toggleSearchModal,
  header: selectHeader(state),
  isFetching: selectIsFetching(state),
  error: selectError(state)
})

const mapDispatchToProps = dispatch => ({
  createUserEvent: event => dispatch(createEvent(event)),
  clearDevice: () => dispatch(clearDevice()),
  fetchHeader: (language, version) => dispatch(fetchHeader.request(language, version))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OptionsHOC(LanguageProvider(HeaderContainer)))



// WEBPACK FOOTER //
// ./src/containers/Header/Header.js